"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseIMSchema = exports.LicenseSchema = exports.BaseLicenseSchema = exports.LicenseMilestoneSchema = exports.LicenseActionsSchema = void 0;
const zod_1 = require("zod");
const patent_schema_1 = require("./patent-schema");
const case_1 = require("./case");
const licensee_schema_1 = require("./licensee-schema");
const license_file_schema_1 = require("./license-file-schema");
const license_enums_1 = require("../enums/license-enums");
/***************** LICENSE ***********************/
exports.LicenseActionsSchema = zod_1.z.object({
    hasCompletedDueDiligence: zod_1.z.boolean(),
    hasUploadedAgreement: zod_1.z.boolean(),
});
exports.LicenseMilestoneSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, { message: 'Name is required' }),
    description: zod_1.z.string().nullish(),
    dueDate: zod_1.z.coerce.date().nullish(),
    completed: zod_1.z.boolean(),
});
exports.BaseLicenseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    actions: exports.LicenseActionsSchema,
    ipType: license_enums_1.IPTypeSchema,
    licenseeId: zod_1.z.string(),
    patentId: zod_1.z.string().nullish(),
    caseId: zod_1.z.string(),
    verified: zod_1.z.boolean().default(false), // When all actions are completed then the License becomes verified
    milestones: zod_1.z.array(exports.LicenseMilestoneSchema).default([]),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    startDate: zod_1.z.coerce.date().nullish(),
    terminationDate: zod_1.z.coerce.date().nullish(),
});
exports.LicenseSchema = zod_1.z.lazy(() => exports.BaseLicenseSchema.extend({
    licensee: zod_1.z.lazy(() => licensee_schema_1.BaseLicenseeSchema),
    patent: zod_1.z.lazy(() => patent_schema_1.BasePatentSchema).nullish(),
    case: zod_1.z.lazy(() => case_1.BaseCaseSchema),
    files: zod_1.z.lazy(() => zod_1.z.array(license_file_schema_1.BaseLicenseFileSchema)).nullish(),
}));
exports.LicenseIMSchema = zod_1.z.lazy(() => exports.BaseLicenseSchema.omit({
    id: true,
    updatedAt: true,
    createdAt: true,
}));
